"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_hook_form_1 = require("react-hook-form");
const TableGlobalError = () => {
    var _a, _b;
    const { formState } = (0, react_hook_form_1.useFormContext)();
    const globalError = (_b = (_a = formState.errors.rows) === null || _a === void 0 ? void 0 : _a._rowError) === null || _b === void 0 ? void 0 : _b.message;
    return react_1.default.createElement(react_1.default.Fragment, null, globalError && react_1.default.createElement("div", { className: "global-table-error" }, globalError));
};
exports.default = TableGlobalError;
